<template>
  <div class="confirmWrap">
    <div class="pt40 messageWrap" v-for="item in applyStepList" :key="`echo-${item.componentName}`">
      <p class="messageTitle">{{ getSortName(item.idx) }}{{ $t(item.title) }}</p>
      <div class="mt20">
        <component :is="item.componentName" :isReadonly="true"></component>
      </div>
    </div>
  </div>
</template>

<script>
import EnrollIntitle from "../intitle/index";
import EnrollQuestionnaire from "../questionnaire/index";
import EnrollEstablish from "../establish/index";
import EnrollUpload from "../upload/index";
import EnrollQuotation from "../quotation/index";
import { mapState, mapGetters } from "vuex";
export default {
  name: "Confirm",
  props: {
    orderDetails: {
      type: Object,
    },
  },
  components: {
    EnrollIntitle,
    EnrollQuestionnaire,
    EnrollEstablish,
    EnrollUpload,
    EnrollQuotation,
  },
  data() {
    return {
      applyStepList: [],
    };
  },
  computed: {
    ...mapState("user", ["isCoordinator"]),
    ...mapGetters("language", ["getLanguage"]),
    ...mapGetters("constant", ["getApplyStepList"]),
    // 获取申请步骤前缀
    getSortName() {
      return index => {
        const procedureObj = {
          zh: ["第一步: ", "第二步: ", "第三步: ", "第四步: "],
          en: ["Step 1: ", "Step 2: ", "Step 3: ", "Step 4: "],
        };
        const name = this.getLanguage == "zh" ? procedureObj.zh[index] : procedureObj.en[index];
        return name;
      };
    },
  },
  methods: {
    // 初始化
    init() {
      // 设置申请步骤
      const list = this.getApplyStepList();
      const resArr = list.filter(item => item.componentName);
      this.applyStepList = resArr;
    },
  },
};
</script>

<style lang="scss" scoped>
.messageTitle {
  font-size: 18px;
  line-height: 1em;
  font-weight: bold;
}
</style>
